import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

import { BrowserRouter } from 'react-router-dom'
import { Analytics } from "@vercel/analytics/react";

const preventDevTools = () => {

  document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    return false;
  });
  document.addEventListener('keydown', (e) => {
    if (
      e.keyCode === 123 ||
      (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67))
    ) {
      e.preventDefault();
      return false;
    }
  });
};

if (process.env.REACT_APP_isDevelopment) {
  preventDevTools();
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <App />
      <Analytics />
    </React.StrictMode>
  </BrowserRouter>
)
